import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ISort,
  ISortBy,
  ISortTypes,
  ISortTypesTranslations,
} from "./sort.interfaces";

export const initialIndexes: ISortBy = {
  penaltyPoints: [],
  price: [],
  flightTime: [],
};

export const initialState: ISort = {
  sortType: "penaltyPoints",
  filteredIndexes: initialIndexes,
};

export const sortSlice = createSlice({
  name: "sort",
  initialState,
  reducers: {
    changeSortType: (state, action: PayloadAction<ISortTypes>) => {
      state.sortType = action.payload;
    },

    changeFilteredIndexes: (state, action: PayloadAction<ISortBy>) => {
      state.filteredIndexes = action.payload;
    },
  },
});

export const { changeSortType, changeFilteredIndexes } = sortSlice.actions;

export const sortTypeMap = {
  penaltyPoints: "best" as ISortTypesTranslations,
  price: "cheapest" as ISortTypesTranslations,
  flightTime: "fastest" as ISortTypesTranslations,
};
